import { isEnumMember } from "@common/helpers/typeGuards";
import {
    ACTIVITY_OUTCOME_PRIORITY,
    ActivityOutcomeKind as Kind,
} from "@common/schemas/domains/activity/activity-outcomes.schema";

/** An outcome's name in the outcome filter. */
export const ACTIVITY_OUTCOME_LABELS: Record<Kind, string> = {
    [Kind.TASKS_COMPLETED]: "Tasks completed",
    [Kind.TASKS_ASSIGNED_TO_VIEWER]: "Tasks assigned to you",
    [Kind.TRANSACTIONS_CATEGORIZED]: "Transactions categorized",
    [Kind.BLOCKING_TASKS_ADDED]: "Blocking tasks added",
    [Kind.JOURNAL_ENTRIES_POSTED]: "Journal entries posted",
    [Kind.TRANSACTIONS_RECATEGORIZED]: "Transactions recategorized",
    [Kind.JOURNAL_ENTRIES_UPDATED]: "Journal entries updated",
    [Kind.JOURNAL_ENTRIES_REVERSED]: "Journal entries reversed",
    [Kind.ACCOUNTS_RECONCILED]: "Accounts reconciled",
    [Kind.TRANSFERS_MATCHED]: "Transfers matched",
    [Kind.TRANSACTIONS_SPLIT]: "Transactions split",
    [Kind.ACCOUNTS_MERGED]: "Accounts merged",
    [Kind.ACCOUNTS_DELETED]: "Accounts deleted",
    [Kind.TRANSACTIONS_UPDATED]: "Transactions updated",
    [Kind.TRANSFERS_UNMATCHED]: "Transfers unmatched",
    [Kind.SPLITS_REMOVED]: "Splits removed",
    [Kind.ACCOUNTS_UPDATED]: "Accounts updated",
    [Kind.TASKS_CREATED]: "Tasks created",
    [Kind.TASKS_DELETED]: "Tasks deleted",
    [Kind.MEMBERS_ADDED]: "Members added",
    [Kind.MEMBERS_REMOVED]: "Members removed",
    [Kind.INVITES_SENT]: "Invites sent",
};

const ORGANIZATION_ONLY_OUTCOMES: readonly Kind[] = [
    Kind.MEMBERS_ADDED,
    Kind.MEMBERS_REMOVED,
    Kind.INVITES_SENT,
];

const TASK_OUTCOMES: readonly Kind[] = [
    Kind.TASKS_COMPLETED,
    Kind.TASKS_ASSIGNED_TO_VIEWER,
    Kind.BLOCKING_TASKS_ADDED,
    Kind.TASKS_CREATED,
    Kind.TASKS_DELETED,
];

/** The outcomes a workspace can have, most important first. */
export const WORKSPACE_ACTIVITY_OUTCOMES = ACTIVITY_OUTCOME_PRIORITY.filter(
    (outcome) => !ORGANIZATION_ONLY_OUTCOMES.includes(outcome),
);

/** The outcomes an organization can have, most important first: its History reads only task, member and invite changes. */
export const ORGANIZATION_ACTIVITY_OUTCOMES = ACTIVITY_OUTCOME_PRIORITY.filter(
    (outcome) =>
        TASK_OUTCOMES.includes(outcome) ||
        ORGANIZATION_ONLY_OUTCOMES.includes(outcome),
);

/** Whether a string is an outcome kind, e.g. one read back from a filter value. */
export const isActivityOutcomeKind = isEnumMember(Kind);
